import type { MaybeComputedRef } from "@vueuse/shared";
import type { WritableComputedRef } from "vue-demi";
import useUserStore from "~/stores/user";
import { COMMERCE_CATEGORY } from "~/constants";
import { getCommerceCategory } from "~/utils/commerce";

export default function useEventCommerce(commerceCoverage: MaybeComputedRef<TCommerceCategory[]>) {
  const { t } = useI18n();
  const userStore = useUserStore();

  const commerceCategoryCoverage: WritableComputedRef<TCommerceCategory[]> = resolveRef(commerceCoverage);
  const isLoggedIn = computed(() => Boolean(userStore.user));

  const commerceCategory = computed(() => getCommerceCategory(commerceCategoryCoverage.value));

  const commerceType = computed(() => {
    if (commerceCategory.value === COMMERCE_CATEGORY.MEMBER)
      return t("labels.commerce_category_labels.member");
    if (commerceCategory.value === COMMERCE_CATEGORY.PPV || commerceCategory.value === COMMERCE_CATEGORY.SUBSCRIPTION)
      return t("labels.commerce_category_labels.premium");
    return t("labels.commerce_category_labels.free");
  });

  const userType = computed(() => {
    if (!isLoggedIn.value)
      return "free";
    if (commerceCategory.value === COMMERCE_CATEGORY.SUBSCRIPTION)
      return "subscription";
    if (commerceCategory.value === COMMERCE_CATEGORY.PPV)
      return "ppv";
    return "member";
  });

  return { commerceType, userType };
}
